import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { PagedResult } from '../../models/pagination.model';

@Component({
  selector: 'app-pagination',
  template: `
    <div class="pagination-bar" *ngIf="result && result.totalPages > 1">
      <div class="pagination-info">
        Mostrando <strong>{{ from }}–{{ to }}</strong> de
        <strong>{{ result.totalCount }}</strong> registros
      </div>
      <nav class="pagination-nav">
        <button class="pg-btn" [disabled]="!result.hasPrevious" (click)="go(1)" title="Primeira">
          «
        </button>
        <button class="pg-btn" [disabled]="!result.hasPrevious" (click)="go(result.page - 1)" title="Anterior">
          ‹
        </button>
        <button *ngFor="let p of pages"
                class="pg-btn"
                [class.active]="p === result.page"
                [class.ellipsis]="p === -1"
                [disabled]="p === -1"
                (click)="p !== -1 && go(p)">
          {{ p === -1 ? '…' : p }}
        </button>
        <button class="pg-btn" [disabled]="!result.hasNext" (click)="go(result.page + 1)" title="Próxima">
          ›
        </button>
        <button class="pg-btn" [disabled]="!result.hasNext" (click)="go(result.totalPages)" title="Última">
          »
        </button>
      </nav>
      <div class="page-size-selector">
        <select [ngModel]="result.pageSize" (ngModelChange)="changeSize($event)">
          <option *ngFor="let s of pageSizes" [value]="s">{{ s }} / pág</option>
        </select>
      </div>
    </div>
  `,
  styles: [`
    .pagination-bar {
      display: flex; align-items: center; gap: 16px; padding: 12px 4px;
      flex-wrap: wrap;
    }
    .pagination-info { font-size: .85rem; color: #666; flex: 1; }
    .pagination-nav  { display: flex; gap: 4px; }
    .pg-btn {
      min-width: 36px; height: 36px; padding: 0 10px;
      border: 1.5px solid #dee2e6; border-radius: 8px;
      background: white; color: #555; font-size: .875rem; cursor: pointer;
      transition: all .15s;
      &:hover:not(:disabled):not(.active) { border-color: #667eea; color: #667eea; background: #f5f7ff; }
      &.active  { background: linear-gradient(135deg,#667eea,#764ba2); color: white; border-color: transparent; }
      &:disabled { opacity: .4; cursor: not-allowed; }
      &.ellipsis { border: none; background: none; }
    }
    .page-size-selector select {
      border: 1.5px solid #dee2e6; border-radius: 8px;
      padding: 6px 10px; font-size: .85rem; color: #555; cursor: pointer;
      &:focus { outline: none; border-color: #667eea; }
    }
  `]
})
export class PaginationComponent implements OnChanges {
  @Input()  result!:    PagedResult<any>;
  @Output() pageChange  = new EventEmitter<number>();
  @Output() sizeChange  = new EventEmitter<number>();

  pages:     number[]  = [];
  pageSizes: number[]  = [10, 20, 50, 100];

  get from() { return this.result ? (this.result.page - 1) * this.result.pageSize + 1 : 0; }
  get to()   { return this.result ? Math.min(this.result.page * this.result.pageSize, this.result.totalCount) : 0; }

  ngOnChanges() { this.buildPages(); }

  go(page: number)      { this.pageChange.emit(page); }
  changeSize(size: number) { this.sizeChange.emit(+size); }

  buildPages() {
    if (!this.result) return;
    const { page, totalPages } = this.result;
    const pages: number[] = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (page > 3)           pages.push(-1);                      // ellipsis esquerdo
      for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++)
        pages.push(i);
      if (page < totalPages - 2) pages.push(-1);                   // ellipsis direito
      pages.push(totalPages);
    }

    this.pages = pages;
  }
}
